import { IBuilding } from "./building";
import { IPlace } from "./place";
import { IUser } from "./user";

export interface IReservation {
  user: IUser,
  building: IBuilding,
  place: IPlace,
  date: Date,
  status: string,
  pem: boolean
}

export enum enStatusCode {
  waitingCheckIn = 'waiting-check-in',
  waitingCheckOut = 'waiting-check-out',
  waitingExperienceForm = 'waiting-experience-form',
  done = 'done',
  canceled = 'canceled',
}

export const enStatus = {
  [enStatusCode.waitingCheckIn]: 'Aguardando Check-in',
  [enStatusCode.waitingCheckOut]: 'Aguardando Check-out',
  [enStatusCode.waitingExperienceForm]: 'Aguardando Formulário de Experiência',
  [enStatusCode.done]: 'Finalizado',
  [enStatusCode.canceled]: 'Cancelado'
}

export const enStatusColor = {
  [enStatusCode.waitingCheckIn]: '#FED925',
  [enStatusCode.waitingCheckOut]: '#0047BA',
  [enStatusCode.waitingExperienceForm]: '#E50695',
  [enStatusCode.done]: '#A2D45E',
  [enStatusCode.canceled]: '#DB0032'
}